import { handleToast } from './handleToast';

export const handleAddToCart = () => {
    // Product listing add to cart button
    document.addEventListener('click', function (e) {
        if (e.target.matches('.js-single-add-to-cart')) {
            e.preventDefault();

            const button = e.target;

            addToCart({
                button: button,
                productId: button.dataset.product_id,
                qty: 1,
                additionalData: {
                    product_price: button.dataset.product_price,
                },
            });
        }
    });

    document.addEventListener('submit', e => {
        const { target } = e;
        if (target.matches('.js-add-to-cart-form')) {
            e.preventDefault();

            const qtyInput = target.querySelector("input[name='qty']");
            const qty = qtyInput ? parseInt(qtyInput.value) : 1;

            addToCart({
                productId: target.dataset.product_id,
                qty: qty,
                additionalData: {
                    product_price: target.dataset.product_price,
                },
            });
        }
    });
};

async function addToCart({
    action = 'mda_add_to_cart',
    button,
    productId,
    qty,
    additionalData = {},
}) {
    const params = new URLSearchParams({
        action: action,
        product_id: productId,
        qty: qty,
        ...additionalData,
    });

    const cartQtyEl = document.querySelector('.header-middle__cart-count.-cart');

    let data = '';

    try {
        handleAjaxBeforeSend();

        const response = await fetch(ajax.url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: params.toString(),
        });

        data = await response.json();
        const { cart_qty, status, text, message } = data;

        if (status && text && status !== 'success') handleToast(status, text);

        if (status && status === 'success') {
            handleToast(status, message);
        }

        if (cart_qty && cartQtyEl) cartQtyEl.textContent = cart_qty;
    } catch (error) {
        console.error('Error:', error);
    } finally {
        handleAjaxSuccess();
    }
}

function handleAjaxBeforeSend() {
    console.log('before');
}

function handleAjaxSuccess(response, button) {
    console.log('end');
}
